import { render, staticRenderFns } from "./indexNew.vue?vue&type=template&id=0172fdbe&scoped=true"
import script from "./indexNew.vue?vue&type=script&lang=js"
export * from "./indexNew.vue?vue&type=script&lang=js"
import style0 from "./indexNew.vue?vue&type=style&index=0&id=0172fdbe&lang=scss&scoped=true"
import style1 from "./indexNew.vue?vue&type=style&index=1&id=0172fdbe&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0172fdbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0172fdbe')) {
      api.createRecord('0172fdbe', component.options)
    } else {
      api.reload('0172fdbe', component.options)
    }
    module.hot.accept("./indexNew.vue?vue&type=template&id=0172fdbe&scoped=true", function () {
      api.rerender('0172fdbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/parkCustomer/page/indexNew.vue"
export default component.exports